import { css } from "styled-components";
import { BladeHeader, BladeHeaderBody, BladeHeaderSupertitle } from "../../../../components/BladeHeader";
import { BladeContent } from "../../../../components/BladeContent";
import { Backdrop, BackdropBackground, BackdropForeground } from "../../../../components/Backdrop";
import { RichText } from "../../../../components/RichText";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    padding: ${chroma.spacers.bladeEdge.topLarge} 0 ${chroma.spacers.bladeEdge.bottomLarge};
    background-color: ${paletteTokens.bladebg1};
    margin: auto;

    ${BackdropBackground} {
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
  }

  &.no-foreground {
    ${BladeContent} {
      ${chroma.mediaQueries.desktopDown} {
        min-height: 640px;
      }

      ${chroma.mediaQueries.tabletDown} {
        min-height: 560px;
      }

      ${chroma.mediaQueries.mobileDown} {
        min-height: 440px;
      }
    }

    ${BladeHeader} {
      max-width: 50%;

      ${chroma.mediaQueries.mobileDown} {
        max-width: 100%;
      }
    }
  }

  ${BladeContent} {
    display: flex;
    flex-direction: row;
    gap: ${chroma.spacers.variable.xl};
    height: 100%;

    ${chroma.mediaQueries.tabletDown} {
      flex-direction: column;
      gap: 0;
      justify-content: flex-end;
    }

    ${Backdrop} {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 50%;

      ${chroma.mediaQueries.tabletDown} {
        width: 100%;
        height: auto;
        margin-top: ${chroma.spacers.variable.m};
      }

      ${BackdropForeground} {
        position: relative;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;

        video {
          object-fit: contain;
        }
      }
    }

    ${BladeHeader} {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-start;
      width: 50%;

      ${chroma.mediaQueries.tabletDown} {
        width: 100%;
      }

      ${BladeHeaderSupertitle} {
        ${chroma.typography.body2};
        font-weight: 600;
        color: ${paletteTokens.bladetext1};
        padding-bottom: ${chroma.spacers.variable.xs};
      }

      h1 {
        ${chroma.typography.display2};
        color: ${paletteTokens.bladetext1};
        padding-bottom: ${chroma.spacers.variable.sm};
      }

      ${BladeHeaderBody} {
        ${RichText} {
          a {
            font-weight: 400;
            color: ${paletteTokens.bladetext3};
            text-decoration: underline;

            &:hover {
              color: ${paletteTokens.bladetext1};
            }
          }
        }

        padding-bottom: ${chroma.spacers.variable.xl};
      }

      .links {
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map